import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { StockBalanceComponent } from './stock-balance.component';

@NgModule({
  declarations: [StockBalanceComponent],
  imports: [
    CommonModule,
    PipesModule,
  ],
  exports: [StockBalanceComponent]
})
export class StockBalanceModule { }
